// import { useEffect, useState } from "react";

// const API_BASE = process.env.REACT_APP_NAV_API;

// export default function CommitmentSummaryCard() {
//   const [data, setData] = useState([]);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   async function fetchData() {
//     try {
//       const res = await fetch(`${API_BASE}/em/commitment-summary`, {
//         credentials: "include"
//       });
//       const json = await res.json();

//       if (json.ok) setData(json.data || []);
//     } catch (e) {
//       console.error(e);
//     }
//   }

//   if (!data.length) {
//     return (
//       <div className="card">
//         <b>No Commitment Score</b>
//       </div>
//     );
//   }

//   function formatDateSafe(v) {
//     if (!v) return "";

//     if (typeof v === "object" && v.value) {
//       return v.value.slice(0, 10);
//     }

//     const s = String(v);
//     const fixed = s.replace(" ", "T");
//     const d = new Date(fixed);

//     if (isNaN(d)) return s.slice(0, 10);
//     return d.toISOString().slice(0, 10);
//   }

//   const meetingDate = formatDateSafe(data[0].created_at);

//   // 🔥 Check if ANY process needs commitment
//   const needsCommitment = data.some(
//     (r) => Number(r.final_score || 0) <= -20
//   );

//   return (
//     <div className="card">
//       <div className="cardTitle">📊 Weekly Performance Summary</div>

//       <div className="mutedSmall">
//         EM Held on ({meetingDate})
//       </div>

//       {/* ================= PREVIOUS SCORE ================= */}
//       <div style={{ marginTop: 10, fontSize:14 }}>
//         <b>Previous Week Score</b>

//         {data.map((r, i) => {
//           const total = Number(r.total_score || 0);
//           const penalty = Number(r.penalty_score || 0);
//           const final = Number(r.final_score || 0);

//           return (
//             <div key={i} style={{ marginTop: 6 }}>
//               <b>{r.process_name}</b>

//               {/* 🔥 CLEAN DISPLAY */}
//               {penalty !== 0 ? (
//                 <div>
//                   Score: {total}, Penalty: {penalty}, Final: {final}
//                 </div>
//               ) : (
//                 <div>Score: {total}</div>
//               )}
//             </div>
//           );
//         })}
//       </div>

//       {/* ================= COMMITMENT ================= */}
//       <div style={{ marginTop: 14 }}>
//         <b>Commitment:</b>

//         {!needsCommitment ? (
//           <div className="mutedSmall" style={{ marginTop: 6 }}>
//             No commitment required for this week
//           </div>
//         ) : (
//           data.map((r, i) => {
//             const finalScore = Number(r.final_score || 0);

//             if (finalScore <= -20) {
//               return (
//                 <div key={i} style={{ marginTop: 6 }}>
//                   <b>{r.process_name}:</b>{" "}

//                   {r.doer_commitment_score !== null &&
//                    r.doer_commitment_score !== undefined ? (
//                     <>
//                       {r.doer_commitment_score}
//                       {r.doer_commitment_remark && (
//                         <span> ({r.doer_commitment_remark})</span>
//                       )}
//                     </>
//                   ) : (
//                     <span style={{ color: "#dc2626" }}>
//                       No Commitment Given Yet
//                     </span>
//                   )}
//                 </div>
//               );
//             }

//             return null;
//           })
//         )}
//       </div>
//     </div>
//   );
// }









import { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_NAV_API;

export default function CommitmentSummaryCard() {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    try {
      const res = await fetch(`${API_BASE}/em/commitment-summary`, {
        credentials: "include"
      });

      const json = await res.json();

      if (json.ok) setData(json.data || []);
    } catch (e) {
      console.error(e);
    }
  }

  if (!data.length) {
    return (
      <div className="card">
        <div className="cardTitle" style={{ fontSize: "13px", fontWeight: 700 }}>
          📊 Weekly Performance Summary
        </div>
        <div className="mutedSmall" style={{ marginTop: 8, fontSize: "12px" }}>
          No score recorded for you this week.
        </div>
      </div>
    );
  }

  function formatDateSafe(v) {
    if (!v) return "";

    if (typeof v === "object" && v.value) {
      return v.value.slice(0, 10);
    }

    const s = String(v);
    const fixed = s.replace(" ", "T");
    const d = new Date(fixed);

    if (isNaN(d)) return s.slice(0, 10);

    return d.toISOString().slice(0, 10);
  }

  const meetingDate = formatDateSafe(data[0]?.created_at);

  // 🔥 Check if ANY process needs commitment
  const needsCommitment = data.some(
    (r) => Number(r.final_score || 0) <= -20
  );

return (
  <div className="card">

    {/* ================= TITLE ================= */}
    <div
      className="cardTitle"
      style={{
        fontSize: "13px",
        fontWeight: 700
      }}
    >
      📊 Weekly Performance Summary
    </div>

    {/* ================= EM DATE ================= */}
    <div
      className="mutedSmall"
      style={{
        marginTop: 8,
        fontSize: "12px"
      }}
    >
      EM Held on ({meetingDate})
    </div>

    {/* ================= PREVIOUS SCORE ================= */}
    <div style={{ marginTop: 0 }}>
      <div
        style={{
          fontWeight: 600,
          fontSize: "12px"
        }}
      >
        Previous Week Score
      </div>

      {data.map((r, i) => {
        const total = Number(r.total_score || 0);
        const penalty = Number(r.penalty_score || 0);
        const final = Number(r.final_score || 0);

        const scoreValue = penalty !== 0 ? final : total;

        const scoreBg =
          scoreValue <= -20
            ? "#ff5858"
            : "#1ec056";

        const scoreColor =
          scoreValue <= -20
            ? "#080808"
            : "#050505";

        return (
          <div
            key={i}
            style={{
              marginTop: 3,
              fontSize: "12px",
            }}
          >
            <b>{r.process_name}</b> -{" "}

            {penalty !== 0 ? (
              <>
                Score: {total},
                {" "}Penalty: {penalty},
                {" "}Final Score:{" "}

                <span
                  style={{
                    background: scoreBg,
                    color: scoreColor,
                    padding: "1px 5px",
                    borderRadius: 6,
                    fontWeight: 600,
                    display: "inline-block",
                    fontSize: "12px"
                  }}
                >
                  {final}
                </span>
              </>
            ) : (
              <>
                Score:{" "}

                <span
                  style={{
                    background: scoreBg,
                    color: scoreColor,
                    padding: "2px 8px",
                    borderRadius: 6,
                    fontWeight: 600,
                    display: "inline-block",
                    fontSize: "12px"
                  }}
                >
                  {total}
                </span>
              </>
            )}
          </div>
        );
      })}
    </div>

    {/* ================= COMMITMENT ================= */}
    <div style={{ marginTop: 10}}>
      <div
        style={{
          fontWeight: 600,
          fontSize: "12px"
        }}
      >
        Current Week Commitment
      </div>

      {!needsCommitment ? (
        <div
          className="mutedSmall"
          style={{
            fontSize: "12px"
          }}
        >
          No commitment required for this week
        </div>
      ) : (
        data.map((r, i) => {
          const finalScore = Number(r.final_score || 0);

          if (finalScore <= -20) {
            return (
              <div
                key={i}
                style={{
                  marginTop: 5,
                  fontSize: "12px",
                  lineHeight: 1.5
                }}
              >
                {r.doer_commitment_score !== null &&
                r.doer_commitment_score !== undefined ? (
                  <>
                    <b>{r.process_name}</b> -{" "}
                    {r.doer_commitment_score}

                    {r.doer_commitment_remark && (
                      <span>
                        {" "}
                        ({r.doer_commitment_remark})
                      </span>
                    )}
                  </>
                ) : (
                  <>
                    <b>{r.process_name}</b> -{" "}
                    <span
                      style={{
                        color: "#dc2626",
                        fontWeight: 500,
                        fontSize: "12px"
                      }}
                    >
                      No Commitment Given Yet
                    </span>
                  </>
                )}
              </div>
            );
          }

          return null;
        })
      )}
    </div>

  </div>
);
}